import { useContext } from 'react';
import BudgetFriendlyCarousel from '@/common/BudgetFriendlyCarousel';
import PopularBodyStyles from '@/common/PopularBodyStyles';
import ShopPopularModels from '@/common/ShopPopularModels';
import RecentSearches from '@/home/ReturnUser/RecentSearches';
import RecommendedCarousels from '@/home/ReturnUser/RecommendedCarousels';
import { useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/home/GlobalContext';
import HeroSection from './HeroSection';
import TopCarousels from './TopCarousels';
import MarketingCarousel from '../common/MarketingCarousel';
import PriceDropBanner from '../common/PriceDropBanner';

export default function ReturnUser() {
  const isNative = useIsNative();
  const { displayLowerFoldOnNative } = useContext(GlobalContext);
  const showRecommendedCarousels = isNative ? displayLowerFoldOnNative : true;

  return (
    <main data-testid="home-return-user">
      <HeroSection />
      <TopCarousels />
      <RecentSearches />
      <PriceDropBanner />
      <PopularBodyStyles eventName="Home Feed Section" />
      <BudgetFriendlyCarousel eventName="Home Feed Section" />
      {showRecommendedCarousels && <RecommendedCarousels />}
      <div className="bg-background-default">
        <MarketingCarousel />
      </div>
      <ShopPopularModels eventName="Home Feed Section" hasCompactSpacing />
    </main>
  );
}
